import { httpClient } from '@/services/http/httpClient'

type DownloadReportResponse = {
  message: string
}

export type FiltersDownloadReportRankingInteractions = {
  areaIds?: string[]
  campaignIds?: string[]
  initialDate?: string
  finalDate?: string
}

export async function getDownloadReport({
  query,
}: {
  query?: FiltersDownloadReportRankingInteractions
}): Promise<DownloadReportResponse> {
  const {
    areaIds = [],
    campaignIds = [],
    initialDate = '',
    finalDate = '',
  } = query ?? {}
  const queryParams = new URLSearchParams({
    areaIds: JSON.stringify(areaIds),
    campaignIds: JSON.stringify(campaignIds),
    initialDate,
    finalDate,
  }).toString()

  const { data } = await httpClient.get(
    `/ideas/campaigns/reports/ranking-interactions?${queryParams}`,
  )

  return {
    message: data.message,
  }
}
